import html from './summary.html';
import lang from './summary.lang.json';
import server from '../../../client/asis-server.js';
import * as directives from '../../../client/globals/directives.js';
import * as mixins from '../../../client/globals/mixins.js';


export default {
    template: html,

    i18n: {
        messages: lang
    },

    mixins: [
        mixins.loadDataOnCreate, 
        mixins.hasRole, 
        directives.label_required, 
        mixins.storeGetters(['lang'],'asis/ui'),
    ],

    data: function() {
        return {
            poll: {},                                 // definition of the poll
            questions: {},                            // definition of questions
            results: {},                              // user responses
            response_count: 0,                        // response counts
        };
    },

    methods: {
        load() {
            server.request(
                this.$parent.module_name, 'poll-summary',
                this.$route.params, null,
                (data, extra)=>{
                    this.poll = data.poll;
                    this.questions = Object.fromEntries(data.questions.map(obj => [obj.question_id, obj]));
                    this.results = data.response_summary;
                    this.response_count = data.response_count;
                }
            );
        },

    }
};

